import { render, staticRenderFns } from "./edit.vue?vue&type=template&id=22e35bbd&"
import script from "./edit.vue?vue&type=script&lang=js&"
export * from "./edit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/easy_dev/extranet/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('22e35bbd')) {
      api.createRecord('22e35bbd', component.options)
    } else {
      api.reload('22e35bbd', component.options)
    }
    module.hot.accept("./edit.vue?vue&type=template&id=22e35bbd&", function () {
      api.rerender('22e35bbd', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/admin/secteurgeo/edit.vue"
export default component.exports